<template>
    <div>
    <div v-if="getAxiosRefresh == 3">{{initData()}}</div>
    <div v-if="getTaskPreparedEdit>-1">{{prepareEdit(getTaskPreparedEdit)}}</div>

    <v-layout row wrap v-if="getAxiosRefresh == -1 && myContent">
        <v-expansion-panels
                v-model="panels"
                multiple
                flat
                class="px-6"
            >
        <v-expansion-panel>
            <v-expansion-panel-header><b>Assignment</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-flex xs12>                 
                <v-layout row wrap>               
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden read-only--background read-only--border-color', 
                                (getTaskVertic == true) ? 'rounded-tl-lg rounded-tr-lg':'rounded-tl-lg rounded-bl-lg']">

                            <div v-if="myContent.languages[getShowTaskIndex].permissions && !myContent.islocked" class="universal-row-item__group-btn-panel read-only--border-color">
                                <div class="lang-side">
                                    <img class="lang-side__img" :src="getLanguageIcons[getShowTaskIndex].url" />
                                </div>
                                <v-icon @click="prepareEdit(getShowTaskIndex)" dense>edit</v-icon>
                                <v-icon @click ="clearTranslation(getShowTaskIndex)" dense>delete</v-icon>                                
                                <v-icon v-if="myContent.languages[getShowTaskIndex].visible == 0" @click="changeVisibility(getShowTaskIndex)" dense>visibility_off</v-icon>                                       
                                <v-icon v-else @click="changeVisibility(getShowTaskIndex)" dense>visibility</v-icon>  
                                <v-icon class="border-l read-only--border-color" @click="$store.commit('setShowTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                            </div>                         
                            <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).content" class="pa-2"></div>
                            
                            <v-layout class="pa-2">
                                <v-btn small dense @click="getAnswers(JSON.parse(myContent.languages[getShowTaskIndex].content).content,0)" class="flex-grow-0 background-transparent card-custom-button shadow-none read-only--border-color color--high-emphasis">Show §§</v-btn>
                                <div class="flex-grow-1 pa-2 border-all rounded read-only--border-color-faded">
                                    <v-chip v-for="(fd,index) in analysedShow" :key="index" class="mx-1">{{fd}}</v-chip>
                                </div>
                            </v-layout>
                    </v-flex>

                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1"
                        :class="['card-border-style position-relative overflow-hidden', 
                                (getShowTaskIndex > -1 && getTaskVertic == false) ? 'border-l-none rounded-tr-lg rounded-br-lg':'', 
                                (getShowTaskIndex > -1 && getTaskVertic == true) ? 'border-t-none rounded-br-lg rounded-bl-lg':'', 
                                (getShowTaskIndex > -1) ? '':'rounded-lg']">

                        <div class="universal-row-item__group-btn-panel">
                            <div class="lang-side">
                                <img class="lang-side__img" :src="getLanguageIcons[getEditTaskIndex].url" />
                            </div>

                            <v-menu v-if="getShowTaskIndex > -1" class="lang-wrapper" top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none" title="copy parts" dense>
                                    content_copy
                                    </v-icon>
                                </template>
                                    <v-list dense>
                                    <v-list-item-group>
                                        <v-list-item v-for="(copy, index) in copies" :key="index" @click="copyContent(copy.list)"> 
                                            <v-list-item-title>{{copy.name}}</v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                    </v-list>
                                </v-menu> 
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" dense>save</v-icon>
                            <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" dense>check_circle</v-icon>
                            <v-icon title="close without save" @click="closeTask()" dense>meeting_room</v-icon>
                            
                            <v-icon class="border-l" @click="$store.commit('setEditTaskIndex', -1); $store.commit('setTaskVertic', true)" dense>cancel</v-icon>
                        </div>
                        <v-card flat class="pa-2">                            
                            <quill-editor v-model='tmpContent' :options="getEditorOption('manual buttons')" ref="myQuill">
                                <div id="toolbar1" slot="toolbar">
                                    <span class="ql-formats">
                                        <button class="ql-header" value="1"></button>
                                        <button class="ql-header" value="2"></button>
                                    </span>        
                                    <span class="ql-formats">
                                        <button class="ql-bold"></button>
                                        <button class="ql-italic"></button>
                                        <button class="ql-underline"></button>
                                        <button class="ql-strike"></button>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-code-block"></button>
                                        <select class="ql-color"></select>
                                        <select class="ql-background"></select>
                                    </span>
                                    <span class="ql-formats">
                                        <select class="ql-align"></select>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-link"></button>
                                        <button class="ql-image"></button>
                                    </span>
                                    <span class="ql-formats">
                                        <button class="ql-clean"></button>
                                    </span>

                                    <span class="ql-formats">
                                        <button title="mark as hidden part" @click="markAsUnknown()"><v-icon>compress</v-icon></button>
                                    </span>
                                </div>
                            </quill-editor>
                            <v-layout class="my-3">
                                <v-btn small dense @click="getAnswers(tmpContent,1)" class="flex-grow-0 background-transparent card-custom-button shadow-none color--high-emphasis">Show §§</v-btn>
                                <div class="flex-grow-1 pa-2 rounded card-border-style">
                                    <v-chip v-for="(fd,index) in analysedEdit" :key="index" class="mx-1">{{fd}}</v-chip>
                                </div>
                            </v-layout>                                          
                        </v-card>
                    </v-flex>                    
                </v-layout>
                </v-flex>
            </v-expansion-panel-content>
        </v-expansion-panel>        
        
        <v-expansion-panel v-if="myContent.task_type_id == 6">
            <v-expansion-panel-header><b>Fake words</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>                      
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                            <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                                <v-chip v-for="(fk,index) in JSON.parse(myContent.languages[getShowTaskIndex].content).fakes" :key="index">{{fk}}</v-chip>
                            </div>
                    </v-flex>
                    <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <v-card flat>  
                            <v-card-text>
                                <div v-if="tmpFakes.length > 0">Click to delete</div>
                                <v-chip v-for="(fk,index) in tmpFakes" :key="index" @click="tmpFakes.splice(index,1)">{{fk}}</v-chip>
                            </v-card-text>
                            <v-card-actions>
                                <v-text-field
                                    label="Insert new fake"
                                    placeholder="Type and press Enter"
                                    v-model = "new_fake"
                                    @keydown.enter.prevent="addFake()"
                                ></v-text-field>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
            <v-expansion-panel-header><b>Help</b></v-expansion-panel-header>
            <v-expansion-panel-content>            
            <v-layout row wrap>                      
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getShowTaskIndex > -1" class="pa-2">
                    <div class="read-only--background border-all read-only--border-color pa-2 fill-height">
                        <div v-html="JSON.parse(myContent.languages[getShowTaskIndex].content).help" class="pa-2"></div>
                    </div>
                </v-flex>
                <v-flex :xs12="getTaskVertic" :xs6="!getTaskVertic" v-if="getEditTaskIndex > -1" class="pa-2">
                        <quill-editor v-model='tmpHelp' :options="getEditorOption()" />                        
                </v-flex>
            </v-layout>                        
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>            
            <v-expansion-panel-header><b>Settings</b></v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-layout row wrap>
                    <v-flex xs1>                                                        
                        <v-text-field
                            v-model="myContent.max_score"
                            label="Max score:"
                            outlined
                            :rules="[rules.required, rules.content, rules.size]"
                            :readonly = "!objectChangePermission"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs1>  </v-flex>
                    <v-flex xs3>
                        <v-checkbox
                            v-model="myGlobals.ignoreSpace"
                            label="Ignore spaces"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.ignoreSeparators"
                            label="Ignore separators (-_,.)"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.caseSensitive"
                            label="Case sensitive"
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                        <v-checkbox
                            v-model="myGlobals.aqSome"
                            label="Apostrophe and quotation marks are the same "
                            :readonly="!objectChangePermission"
                        ></v-checkbox>     
                    </v-flex>
                    <v-flex xs2></v-flex>
                    <v-flex xs4 v-if="objectChangePermission"> 
                        <v-layout row justify-end>                                               
                            <v-menu class="lang-wrapper" top>                        
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on" class="lang-change-widget background-transparent shadow-none">
                                <v-btn class="background-transparent card-custom-button shadow-none">
                                    <v-icon class="mr-3 pr-3 border-r" dense>
                                        {{task_icons[myContent.task_type_id-1].icon}}                             
                                    </v-icon>
                                    {{task_icons[myContent.task_type_id-1].descr}}  
                                </v-btn>    
                                </div>                                               
                            </template>
                                <v-list dense>
                                <v-list-item-group>
                                    <v-list-item @click="myContent.task_type_id = 5">
                                        <v-icon style="margin-right:3px">{{task_icons[4].icon}}</v-icon><v-list-item-title v-text="task_icons[4].descr"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="myContent.task_type_id = 6">
                                        <v-icon style="margin-right:3px">{{task_icons[5].icon}}</v-icon><v-list-item-title v-text="task_icons[5].descr"></v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                                </v-list>
                            </v-menu>                              
                        </v-layout>
                    </v-flex>
                </v-layout>               
            </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>  
        </v-layout>

        <v-layout v-if="myContent && getEditTaskIndex>-1" class="d-flex align-end flex-column border-t mt-5 pa-2">
            <div class="btn-group-a">
                <img class="btn-group-a__divider-item" :src="getLanguageIcons[getEditTaskIndex].url" width="20" />
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save without close" @click="saveData(false, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--green" dense>save</v-icon>
                <v-icon v-if="!myContent.islocked && !(myContent.id > 0 && getCountdownStatus.count <= 0)" title="save and close" @click="saveData(true, getEditTaskIndex, objectChangePermission?0:1)" class="btn-group-a__button btn-group-a__button--blue" dense>check_circle</v-icon>
            </div>
        </v-layout>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import * as es from '../../../../assets/editor_settings.js'
import axios from '../../../../axios-auth'
import * as icn from '../../../../assets/task_icons.js'
import * as misc from '../../../../assets/misc.js'

export default {
    data() {
        return {
                myContent: null,
                myGlobals: null,
                task_icons: [],
                tmpContent: '',
                tmpHelp: '',
                tmpFakes: [],
                new_fake: '',
                analysedShow: [],
                analysedEdit: [],
                rules: {
                    required: value => !!value || 'Required.',
                    size: value => value > 0 && value < 1000 || 'Out of size.',
                    content: value => {
                        const pattern = /^\d+$/
                        return pattern.test(value) || 'Invalid value.'
                    }
                },
                copies: [ { name: 'content', list: ['content'] }, // menu content
                          { name: 'fakes', list: ['fakes'] },
                          { name: 'content, help', list: ['content', 'help'] },
                          { name: 'content, help, fakes', list: ['content', 'help', 'fakes'] },
                ],
                panels : [0]
              }
    },
    props: {
        my_element: Object, 
        objectChangePermission : Boolean
    },
    computed: 
            mapGetters([
                        'getLanguageIcons',
                        'getCountdownStatus',
                        'getShowTaskIndex',
                        'getEditTaskIndex',
                        'getTaskVertic',
                        'getTaskPreparedEdit',
                        'getShowModalMessageResult',
                        'getAxiosRefresh'
                        ])
    ,
    components: {
        quillEditor
    },
    mounted() {
        if (this.getAxiosRefresh !=3 ) this.initData()
    },
    methods: {
        // ************ main methods
        getEditorOption(_version) { return es.getEditorOption(_version) },
        getCmOptions() { return es.getCmOptions('text/html', false) },   
        changeVisibility(_index) {
            this.$store.commit('setTaskNewVisibility', 1 - this.myContent.languages[_index].visible)
            this.$store.commit('setTaskChangeVisibility', true)
            this.myContent.languages[_index].visible = 1 - this.myContent.languages[_index].visible                   
        },
        prepareEdit(_index) {  
            this.$store.commit('setTaskPreparedEdit',-1)  
            if (!this.myContent.languages[_index].permissions || this.myContent.islocked) return
            this.$store.commit('setEditTaskIndex', _index)
            this.prepareContent()
        },
        closeTask() { this.$router.go(-1) },

        // ******** end of main methods
        // *********************************

        initData() {
            // this.$store.commit('setFeedback', null)
            this.$store.commit('setAxiosRefresh',-1)
            this.myContent = this.my_element
            this.task_icons = icn.getIcons()
            this.myGlobals = {
                ignoreSpace: false,   
                ignoreSeparators: false,   
                caseSensitive: true,
                aqSome: false   
            }

            const _glob = misc.getFromJSON(this.myContent.globals,'')
            if (_glob != '') {
                if (!isNaN(_glob.ignoreSpace)) this.myGlobals.ignoreSpace = _glob.ignoreSpace
                if (!isNaN(_glob.ignoreSeparators)) this.myGlobals.ignoreSeparators = _glob.ignoreSeparators
                if (!isNaN(_glob.caseSensitive)) this.myGlobals.caseSensitive = _glob.caseSensitive
                if (!isNaN(_glob.aqSome)) this.myGlobals.aqSome = _glob.aqSome
            }

            if (this.$route.params.id == 0) this.myContent.max_score = 10

            if (this.getEditTaskIndex > -1 && (!this.myContent.languages[this.getEditTaskIndex].permissions || this.myContent.islocked)) {
                this.$store.commit('setEditTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
            }
            if (this.getShowTaskIndex == this.getEditTaskIndex) {
                this.$store.commit('setShowTaskIndex', -1)
                this.$store.commit('setTaskVertic',true)
                this.prepareEdit(this.getEditTaskIndex)
            }                    
            this.prepareContent()   
        },
        prepareContent() {
            if (this.getEditTaskIndex < 0) return
            const _json = misc.getFromJSON(this.myContent.languages[this.getEditTaskIndex].content,'')
            this.tmpContent = ''
            this.tmpHelp = ''
            this.tmpFakes = []
            this.analysedEdit = []
            if (_json != '') {
                this.tmpContent = _json.content
                this.tmpHelp = _json.help
                this.tmpFakes = _json.fakes
            } 
        },
        markAsUnknown() {
            const quill = this.$refs.myQuill.quill
            var selection = quill.getSelection();
            if (selection == null || selection.length == 0  ) return
            quill.insertText(selection.index + selection.length, '§§')
            quill.insertText(selection.index, '§§')
            quill.setSelection(selection.index, selection.length + 4)
        },
        getAnswers(_content, _type) {
            const _list = []
            var data = misc.makeNice(misc.unSpan(_content))
            data.replace(/§§(.*?)§§/g, function(match, g1) { 
                _list.push(g1)
            })

            if (_type == 0) {
                this.analysedShow = _list
            }
            if (_type == 1) {
                this.analysedEdit = _list
            }
        },
        addFake() {
            if (this.new_fake.length > 0) {
                this.tmpFakes.push(this.new_fake)
                this.new_fake = ''
            }
        },
        //******************************************************* */

        copyContent(_list) {
            if (this.getShowTaskIndex > -1) {
                const _json = misc.getFromJSON(this.myContent.languages[this.getShowTaskIndex].content,'')
                if (_json != '') {
                    if (_list.includes('content')) this.tmpContent = _json.content
                    if (_list.includes('help')) this.tmpHelp = _json.help
                    if (_list.includes('fakes')) {
                        this.tmpFakes = []
                        for(let i=0; i < _json.fakes.length; i++)
                            this.tmpFakes.push(_json.fakes[i])
                    }
                }              
            }
        },
        saveData(_close, _index, _only_translation) { 
          if (this.myContent.id == 0 && (this.myContent.course_id === undefined || this.myContent.lesson_id === undefined)) {
              this.$store.commit('setFeedback', 'Data about course and/or lesson is missing')
              return
          }
          this.myContent.max_score = isNaN(this.myContent.max_score) ? 10 : this.myContent.max_score

          const _content = {
              content: this.tmpContent,
              help: this.tmpHelp,
              fakes: this.tmpFakes
          }
          const _globals = {
              ignoreSpace: this.myGlobals.ignoreSpace,
              ignoreSeparators: this.myGlobals.ignoreSeparators,
              caseSensitive: this.myGlobals.caseSensitive,
              aqSome: this.myGlobals.aqSome
          }
          const _data = {
            task_id: this.myContent.id,
            course_id: this.myContent.course_id, // will be checked on backend
            lesson_id: this.myContent.lesson_id,
            task_type: 'T',
            task_type_id: this.myContent.task_type_id,
            max_score: this.myContent.max_score,
            content: JSON.stringify(_content), // new data
            globals: JSON.stringify(_globals),
            lang_id: _index + 1,
            only_translation: _only_translation 
          }

        axios.post('/edit-task', _data, this.$store.getters.getAxiosConfig)
          .then(res => {
            if (res.data.message != 'OK') {
              this.$store.commit('setFeedback', res.data.message)
              return
            } 

            this.$store.commit('setShowTaskIndex', _index)
            this.$store.commit('setEditTaskIndex', _index)

            if (this.myContent.id == 0 || this.myContent.task_type_id != this.$route.params.id_type) { // new - refresh                  
                if (this.myContent.id == 0) 
                   this.myContent.id = res.data.task_id
                this.$router.replace({name:'task_edit', params: {
                    id: this.myContent.id,
                    id_type: this.myContent.task_type_id, 
                    show_lang: _index, 
                    edit_lang: _index, 
                    course_id: this.myContent.course_id, 
                    lesson_id: this.myContent.lesson_id
                }})
            } 

            if (_close) this.closeTask()   
            this.$store.commit('setAxiosRefresh', 1)
          })
          .catch(error => {
              this.$store.commit('setFeedback', error)
          }) 
        }
    }
}
</script>

<style>

</style>

